module.exports = __webpack_public_path__ + "img/op_img-header-mobile.dcae0c4.png";